import { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Non-blocking reminder: Sales Partners can sell instantly; bank details are only needed before payouts.
export default function PaymentProfileGate() {
  const { user } = useAuth();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("si_bank_banner_hidden") === "1");
  if (!user || user.role !== "salesperson" || user.payment_profile_complete || hidden) return null;
  const dismiss = () => { sessionStorage.setItem("si_bank_banner_hidden", "1"); setHidden(true); };

  return (
    <div data-testid="payment-profile-reminder" className="mb-6 flex items-center gap-3 rounded-xl border border-[#D4AF37]/30 bg-[#D4AF37]/[0.06] px-4 py-3 min-w-0">
      <ShieldCheck className="w-5 h-5 text-[#D4AF37] shrink-0" />
      <p className="text-sm text-white/75 flex-1 min-w-0">
        You can start selling right away. Add your bank details whenever you're ready so we can pay your commission.
      </p>
      <Link to="/sales/payment-profile" data-testid="payment-profile-reminder-cta"
        className="text-xs rounded-lg px-3 py-1.5 border border-[#D4AF37]/40 text-[#D4AF37] hover:bg-[#D4AF37]/10 shrink-0">Add bank details</Link>
      <button onClick={dismiss} data-testid="payment-profile-reminder-dismiss" aria-label="Dismiss" className="text-white/35 hover:text-white shrink-0"><X className="w-4 h-4" /></button>
    </div>
  );
}
